export default {"src":"/_next/static/media/phone-flawless.9e4d8dfc.svg","height":75,"width":66};